(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-how-to-use"] && !Shopify.designMode) return;
  try {
    
  $('.how_to_use_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2500,
    infinite: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,      
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,      
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,      
        }
      }
    ] 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-with-list-text"] && !Shopify.designMode) return;
  try {
    
  $('a').click(function(){
    $('html, body').animate({
        scrollTop: $( $(this).attr('href') ).offset().top - 50 
    }, 2500);
    return false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-marquee-xmas"] && !Shopify.designMode) return;
  try {
    
  $(".one-time").slick({
    centerMode:true,
    draggable: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 5000,
    infinite: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: true,
    arrows: false,
    variableWidth: true
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-marquee"] && !Shopify.designMode) return;
  try {
    
  $(".one-time").slick({
    centerMode:true,
    draggable: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 5000,
    infinite: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: true,
    arrows: false,
    variableWidth: true
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-rating-product-xmas"] && !Shopify.designMode) return;
  try {
    
  $('.rating_slider').slick({
    slidesToShow: 3,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2500,
          arrows: true,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2500,
          arrows: true,
        }
      }
    ] 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-rating-product"] && !Shopify.designMode) return;
  try {
    
  $('.rating_slider').slick({
    slidesToShow: 3,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2500,
          arrows: true,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2500,
          arrows: true,
        }
      }
    ] 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider-product"] && !Shopify.designMode) return;
  try {
    
  $('.center_slider').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 6,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          centerMode: true,
          slidesToShow: 5,
          arrows: true,      
        }
      },
      {
        breakpoint: 1199,
        settings: {
          
          centerMode: true,
          slidesToShow: 3, 
          arrows: true,      
        }
      },
      {
        breakpoint: 769,
        settings: {
          
          centerMode: true,
          slidesToShow: 3,
          arrows: true,      
        }
      },
       {
        breakpoint: 575,
        settings: {
          variableWidth: true,
          centerMode: true,
          slidesToShow: 1,
          arrows: true,      
        }
      }
    ] 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-social-team"] && !Shopify.designMode) return;
  try {
    
  
  $('.social_team_slider_center').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '60px',
    autoplay: true,
    autoplaySpeed: 15000,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
           variableWidth: true,
        }
      }
    ] 
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-team"] && !Shopify.designMode) return;
  try {
    
  
    jQuery('.team_slider_center').slick({
     centerPadding: '60px',
      centerMode: true,
      slidesToShow: 3,
      arrows: false,
      dots: false,
      variableWidth: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 1500,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1
          }
        }
      ]
    });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header--backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();
})();
